import React from 'react'
import { useSelector } from 'react-redux'

import BaseEntity from 'app/components/BaseEntity'
import constants from 'app/constants'
import {
  fetchPreschoolAnnualLoData,
  updatePreschoolData
} from 'app/store/actions/preschoolEntity'

import { columns } from './config'

/**
 * Annual LOs admin page.
 *
 * CRUD against /api/v1/preschool-evaluation/admin/annual-los/ via the
 * preschoolEntity saga. The catalog is seeded from the curriculum sheet;
 * this page is mainly for editing names/text/order.
 */
const AnnualLOs = () => {
  const data = useSelector(
    (state) => state.preschoolEntityReducer.preschoolAnnualLoData
  )

  return (
    <BaseEntity
      entity={constants.PRESCHOOL_ANNUAL_LO}
      label={constants.PRESCHOOL_ANNUAL_LO_LABEL}
      columns={columns}
      data={data}
      fetchData={fetchPreschoolAnnualLoData}
      updateEntityData={updatePreschoolData}
    />
  )
}

export default AnnualLOs
